import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { NuqsAdapter } from "nuqs/adapters/react";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import "./styles.css";
import { LocalesProvider } from "@/locales/LocalesProvider.tsx";
import { keycloak, keycloakInit } from "@/auth/keycloak.ts";
import { ApiProvider } from "@/api/ApiProvider.tsx";
import { MeDataProvider } from "@/dataProviders/MeDataProvider.tsx";
import { LoginResolver } from "@/auth/LoginResolver.tsx";
import { initSentry } from "@/sentry.ts";
import { ErrorBoundary } from "@sentry/react";
import { CommonError } from "@/components/CommonError.tsx";

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

void keycloakInit();

initSentry();

keycloak.onReady = () => {
  // Render the app
  const rootElement = document.getElementById("app");
  if (rootElement && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <StrictMode>
        <ErrorBoundary fallback={<CommonError />}>
          <LoginResolver>
            <NuqsAdapter>
              <ApiProvider>
                <MeDataProvider>
                  <LocalesProvider>
                    <RouterProvider router={router} />
                  </LocalesProvider>
                </MeDataProvider>
              </ApiProvider>
            </NuqsAdapter>
          </LoginResolver>
        </ErrorBoundary>
      </StrictMode>,
    );
  }
};
